// Angular
import { Component, Output, Input, EventEmitter, OnInit } from "@angular/core";
import { Router } from "@angular/router";
// Local services
import { ClienteService } from "../../services/cliente.service";
// Local data
import * as codigoInstituciones from "../../localDataJson/codigoinstituciones.json";
// 3rd libraries
import * as moment from "moment";
import swal from "sweetalert2";
import { NgxUiLoaderService } from "ngx-ui-loader";
// Common functions
import { CommonFunctions } from "../../utils/common-functions";
import { CurrencyPipe } from "@angular/common";
import { AlertService } from "../../services/alert.service";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";

@Component({
  selector: "app-gestiones-consolidacion-deudas",
  templateUrl: "./gestiones-consolidacion-deudas.component.html",
  styleUrls: ["./gestiones-consolidacion-deudas.component.scss"],
})
export class GestionesConsolidacionDeudasComponent implements OnInit {
  @Output() selecttab = new EventEmitter<number>();
  @Input() clienteserviceParam: ClienteService;
  @Output() setDataCliente = new EventEmitter<any>();
  @Input() datacliente: any;
  totalmontoconsolidar = 0;
  consolidacionExternaTota = 0;
  SolicitudCashOut;
  productosCliente = [];
  tieneTarjeta = "S";
  tieneCreditos = "S";
  tieneProductosE = "S";
  consolidacionExternaTC;
  consolidacionExternaCD;
  montominimocashout;
  montomaximocashout;
  clientData: any = {};
  instituciones: any = (codigoInstituciones as any).default;
  formatterDecimal = new Intl.NumberFormat("es-GT", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
    style: "decimal",
  });
  existProduct = false;
  //variables monto y plazo
  minimumAmount = 0;
  monto;
  plazo;
  constructor(
    private alertService: AlertService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private currencyPipe: CurrencyPipe,
    public router: Router
  ) {
    setTimeout(() => {
      if (this.clienteserviceParam.datosPorductosClientes.length > 0) {
        this.totalmontoconsolidar = this.clienteserviceParam.TotalCosolidacion;
        this.productosCliente = this.clienteserviceParam.datosPorductosClientes;
        this.productosCliente.forEach((item) => {
          if (item.permitidoConsolidar === true) {
            this.existProduct = true;
          }
        });
        this.validateCashout()
        this.setForceConsolidation();
      } else {
        this.setDataproductos(this.clienteserviceParam.getProductosCliente());
      }
      if (this.clienteserviceParam.datosPrecalificacion.monto != null) {
        this.monto = this.clienteserviceParam.datosPrecalificacion.monto;
        this.plazo = this.clienteserviceParam.datosPrecalificacion.plazo;
      }
    }, 500);
  }

  ngOnInit(): void {
    this.clientData = this.clienteserviceParam.datosCliente;
    this.minimumAmount =
      this.clienteserviceParam.datosPrecalificacion.minimumAmount;
  }
  goToAlert() {
    this.selecttab.emit(11);
  }
  setDataproductos(datos) {
    datos.productosUnificadosConsolidables.consolidacionCreditoBT.concat(datos.productosUnificadosConsolidables.consolidacionTarjetaBT).forEach(item=>{
      item.permitidoConsolidar=item.permitidoConsolidar=="true"?true:item.permitidoConsolidar=="false"?false:item.permitidoConsolidar
      if (item.permitidoConsolidar) {
        item.consolida = false
        item.capitalOrig=item.capitalOriginal
        item.consolidacionObligatoria = false
        this.productosCliente.push(item)
      }
    })
    datos.productosUnificadosConsolidables.consolidacionSirc.forEach(item => {
      item.permitidoConsolidar=item.permitidoConsolidar=="true"?true:item.permitidoConsolidar=="false"?false:item.permitidoConsolidar
      if(item.permitidoConsolidar){
        item.consolida=false
        item.consolidacionObligatoria = false
        this.productosCliente.push(item)
      }
    })
    this.existProduct = this.productosCliente.length>0?true:false
  }
  selectProducto(item,index) {
    if(this.productosCliente[index].consolida){
      this.productosCliente[index].consolida = false;
      this.totalmontoconsolidar = this.totalmontoconsolidar -  Number(this.productosCliente[index].saldo);
    }else{
      this.productosCliente[index].consolida=true
      this.totalmontoconsolidar = this.totalmontoconsolidar +  Number(this.productosCliente[index].saldo);
    }
    this.totalmontoconsolidar = +this.totalmontoconsolidar.toFixed(2);
    this.validateCashout()
  }
  consolidarDeudas() {
    let isForceConsolidation = false;
    let findCredit;
    if (this.clienteserviceParam.commonCredits.length > 0) {
      this.clienteserviceParam.commonCredits.forEach((credit) => {
        findCredit = this.productosCliente.find(
          (item) => item.noCredito === credit.noCredito
        );
        if (findCredit && !findCredit.consolida) {
          isForceConsolidation = true;
        }
      });
    }
    if (isForceConsolidation) {
      this.showNotification(
        "Alerta",
        `Para continuar debe de consolidar la deuda interna no: ${
          findCredit.NO_CREDITO
        } con capital original de: Q${this.formatterDecimal.format(
          findCredit.capitalOrig
        )}`
      );
      return;
    } else {
      const auxInternoNoConsolidados=this.productosCliente.filter(i=>i.cPorPagar>1&&i.consolida==false&&i.directoIndirecto=="DIRECTO"&&i.nomEntidad=="BANCO DE LOS TRABAJADORES"&&i.descripcionTipoCredito=="FIDUCIARIOS")
      if (auxInternoNoConsolidados.length < 2 || this.clienteserviceParam.rolVerificacionFlag) {
        if (this.SolicitudCashOut) {
          if (this.monto < this.minimumAmount) {
            this.showNotification('Alerta',`El monto no debe ser menor a Q${this.minimumAmount.toFixed(2)}`)
          } else {
            let aux=(this.monto*100-this.totalmontoconsolidar*100)/100
            let amountformatter=+this.clienteserviceParam.getvalorDecimales(aux.toString())
            this.setCashout( amountformatter) 
          }
        }
        else {
          this.clienteserviceParam.TotalCosolidacion = this.totalmontoconsolidar;
          this.clienteserviceParam.datosPorductosClientes = this.productosCliente;
          this.clienteserviceParam.datosPrecalificacion.montoSolicitudCashOut=0
          this.goToIngresos()
        }
      } else {
        this.showNotification(
          "Alerta",
          "Para continuar debe de consolidar " +
            (auxInternoNoConsolidados.length-1) +
            " deuda interna"
        );
      }
    }
  }
  validateCashout() {
    this.consolidacionExternaTC = 0;
    this.consolidacionExternaCD = 0;
    for (let i = 0; i < this.productosCliente.length; i++) {
      if (
        this.productosCliente[i].consolida == true &&
        this.productosCliente[i].nomEntidad != "BANCO DE LOS TRABAJADORES"
      ) {
        if (
          this.productosCliente[i].descTipoActivo == "Tarjeta de Credito" ||
          this.productosCliente[i].descTipoActivo == "Factoraje"
        ) {
          const saldo = parseFloat(this.productosCliente[i].saldo);
          this.consolidacionExternaTC = this.consolidacionExternaTC + saldo;
        } else {
          const saldo = parseFloat(this.productosCliente[i].saldo);
          this.consolidacionExternaCD = this.consolidacionExternaCD + saldo;
        }
      }
    }
    if (
      this.consolidacionExternaTC >= 5000 ||
      this.consolidacionExternaCD >= 10000
    ) {
      this.SolicitudCashOut = true;
      let montominimo = this.getCashOutMinimumAmount(
        this.totalmontoconsolidar
      );
      montominimo=montominimo+this.totalmontoconsolidar
      const monto = montominimo / 100;
      const montoMultiplo = parseInt(monto.toString());
      this.minimumAmount = montoMultiplo * 100;
      //this.minimumAmount=this.totalmontoconsolidar+this.montominimocashout
    } else {
      const totalconsolidacionext = this.consolidacionExternaTC + this.consolidacionExternaCD;
      if (totalconsolidacionext >= 10000) {
        this.SolicitudCashOut = true;
        let montominimo = this.getCashOutMinimumAmount(
          this.totalmontoconsolidar
        );
        montominimo=montominimo+this.totalmontoconsolidar
        const monto = montominimo / 100;
        const montoMultiplo = parseInt(monto.toString());
        this.minimumAmount = montoMultiplo * 100;
        //this.minimumAmount=this.totalmontoconsolidar+this.montominimocashout
      } else {
        this.SolicitudCashOut = false
        // validation to liquidez
        let montominimo = this.getCashOutMinimumAmount(
          this.totalmontoconsolidar
        );
        montominimo = montominimo + this.totalmontoconsolidar;
        const monto = montominimo / 100;
        const montoMultiplo = parseInt(monto.toString());
        this.minimumAmount = montoMultiplo * 100;
       // this.minimumAmount=montominimocashout
      }
    }
  }

  getCashOutMinimumAmount(amount) {
    if (amount >= 120000) {
      return amount * 0.07;
    }

    if (amount >= 20000 && amount < 120000) {
      return amount * 0.1;
    }

    if (amount >= 3000 && amount < 20000) {
      return amount * 0.13;
    }

    if (amount < 3000) {
      return amount * 0.16;
    }
  }

  showNotification(title, message) {
    swal
      .fire({
        title,
        text: message,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        confirmButtonText: "Continuar",
      })
      .then((result) => {});
  }
  showNotificationMonto(title, message) {
    swal
      .fire({
        title,
        text: message,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        confirmButtonText: "Continuar",
      })
      .then((result) => {
        this.selecttab.emit(8);
      });
  }
  setCashout(amount) {
    this.clienteserviceParam.TotalCosolidacion = this.totalmontoconsolidar;
    this.clienteserviceParam.datosPorductosClientes = this.productosCliente;
    this.clienteserviceParam.datosPrecalificacion.montoSolicitudCashOut = amount.toString();
    this.goToIngresos();
  }
  goBack() {
    this.minimumAmount = 0
    this.clienteserviceParam.datosPorductosClientes = []
    this.clienteserviceParam.datosPrecalificacion.plazo = ''
    this.clienteserviceParam.datosPrecalificacion.monto = ''
    this.clienteserviceParam.datosPrecalificacion.minimumAmount=0
    this.selecttab.emit(16); // volver a productos
  }

  goBackFinishCoDebtor() {
    this.alertService
      .confirmationHMTL(
        `<strong>Nota:</strong>`,
        `<span>Si retorna a la página anterior se perderán los datos de codeudor guardados. ¿Desea continuar?</span><br>`,
        "Continuar",
        "Cerrar"
      )
      .then((confirm) => {
        if (confirm.isConfirmed) {
          this.clienteserviceParam.flowType = "DEBTOR";
          this.clienteserviceParam.datosCodeudor = {};
          this.clienteserviceParam.datosPrecalificacionCodeudor = {};
          this.clienteserviceParam.commonCredits = [];
          this.clienteserviceParam.productosCodeudor = [];
          this.clienteserviceParam.datosPorductosClientes = []
          this.clienteserviceParam.datosPrecalificacion.plazo = ''
          this.clienteserviceParam.datosPrecalificacion.monto = ''
          this.clienteserviceParam.datosPrecalificacion.minimumAmount=0
          this.selecttab.emit(16);
        }
      });
  }

  setForceConsolidation() {
    const commonCredits = this.clienteserviceParam.commonCredits;

    if (commonCredits && commonCredits.length > 0) {
      this.existProduct = true;
      commonCredits.forEach((credit) => {
        this.productosCliente.forEach((item) => {
          if (!credit.permitidoConsolidar && credit.noCredito === item.noCredito) {
            item.consolidacionObligatoria = true;
          }
        });
      });
    }
    this.showForceConsolidationAlert();
  }

  showForceConsolidationAlert() {
    let isForceConsolidation = false;
    let findCredit;
    if (this.clienteserviceParam.commonCredits.length > 0) {
      this.clienteserviceParam.commonCredits.forEach((credit) => {
        findCredit = this.productosCliente.find(
          (item) => item.noCredito === credit.noCredito
        );
        if (findCredit && !findCredit.consolida) {
          isForceConsolidation = true;
        }
      });
    }
    if (isForceConsolidation) {
      this.showNotification(
        "Alerta",
        `Para continuar debe de consolidar la deuda interna no: ${
          findCredit.noCredito
        } con capital original de: Q${this.formatterDecimal.format(
          findCredit.capitalOrig
        )}`
      );
      return;
    }
  }

  showDpiAlert() {
    const dpi = "";
    swal
      .fire({
        title: "Ingrese el DPI del codeudor",
        input: "text",
        inputLabel: "DPI",
        inputValue: dpi,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        inputValidator: (result) =>
          (!result && "Por favor ingrese un número de DPI.") ||
          (result.length !== 13 &&
            "El número de DPI no es válido, favor verifique.") ||
          (result === this.clienteserviceParam.datosCliente.cliente.dpi &&
            "El número de DPI ingresado no puede ser igual al de deudor"),
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        confirmButtonText: "Continuar",
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          this.clienteserviceParam.commonCredits = [];
          this.clienteserviceParam.datosPrecalificacionCodeudor = {};
          this.ngxUiLoaderService.startLoader(
            "loader-global",
            "loadingDashboard"
          );
          this.setDataCliente.emit({
            dpi: result.value,
            flowType: "CODEBTOR",
          });
        }
      });
  }
  goToIngresos() {
    if (this.monto == null || +this.monto<=0) {
      this.showNotification("Alerta", "Debe ingresar un monto valido")
    }
    else if(this.clienteserviceParam.datosPrecalificacion.segmento=="PV" && 
    (this.clienteserviceParam.datosPrecalificacion.codigoSegmentoRiesgoPagoVoluntario=="A"||this.clienteserviceParam.datosPrecalificacion.codigoSegmentoRiesgoPagoVoluntario=="S")&&+this.monto<3500){
      this.showNotification("Alerta", "El monto no debe ser menor a Q3500")
    }
    else if(this.clienteserviceParam.datosPrecalificacion.segmento=="PV" && 
    this.clienteserviceParam.datosPrecalificacion.codigoSegmentoRiesgoPagoVoluntario=="I"&&+this.monto<8000){
      this.showNotification("Alerta", "El monto no debe ser menor a Q8000")
    }else if(this.clienteserviceParam.datosPrecalificacion.segmento!="PV" && +this.monto<1500){
      this.showNotification("Alerta", "El monto no debe ser menor a Q1500")
    }
    else if (this.monto > 300000) {
      this.showNotification("Alerta", "El monto no debe ser mayor a Q300,000.00");
    }
    else if (
      this.minimumAmount > 0 &&
      +this.monto < this.minimumAmount
    ) {
      this.showNotification(
        "Alerta",
        `El monto no debe ser menor a Q${this.formatterDecimal.format(this.minimumAmount)}`
      );
      return;
    } else if (this.plazo == null) {
      this.showNotification("Alerta", "Debe ingresar un plazo");
    }
    else if (this.plazo.toString().includes('.')) {
      this.showNotification("Alerta", "Debe ingresar un plazo valido");
    }else if (this.plazo<6) {
      this.showNotification("Alerta", "El plazo no debe ser menor a 6 meses");
    }
    else if (this.clienteserviceParam.datosPrecalificacion.segmento!="PV"&& this.plazo>120) {
      this.showNotification("Alerta", "El plazo no debe ser mayor a 120 meses");
    }else if(this.clienteserviceParam.datosPrecalificacion.segmento=="PV" && 
    (this.clienteserviceParam.datosPrecalificacion.codigoSegmentoRiesgoPagoVoluntario=="A"||this.clienteserviceParam.datosPrecalificacion.codigoSegmentoRiesgoPagoVoluntario=="S")&&this.plazo>72){
      this.showNotification("Alerta", "El plazo no debe ser mayor a 72 meses");
    }
    else if(this.clienteserviceParam.datosPrecalificacion.segmento=="PV" && 
    this.clienteserviceParam.datosPrecalificacion.codigoSegmentoRiesgoPagoVoluntario=="I"&&this.plazo>60){
      this.showNotification("Alerta", "El plazo no debe ser mayor a 60 meses");
    }
      
    else if (
      this.monto < this.clienteserviceParam.TotalCosolidacion &&
      this.clienteserviceParam.datosPrecalificacion.montoSolicitudCashOut == "0"
    ) {
      this.showNotification(
        "¡Alerta!",
        "El monto debe ser mayor al monto a consolidar Q" +
          this.formatterDecimal.format(
            this.clienteserviceParam.TotalCosolidacion
          )
      );
    } else if (this.monto % 100 != 0) {
      var monto = this.monto / 100;
      var montoMultiplo = parseInt(monto.toString());
      this.monto = montoMultiplo * 100;
      this.goToIngresos();
    } else {
      this.clienteserviceParam.setMontoyPlazo({
        plazo: this.plazo,
        monto: this.monto,
      });
      if(this.clienteserviceParam.datosPrecalificacion.segmento=="PV"&&((this.clienteserviceParam.datosPrecalificacion.codigoSegmentoRiesgoPagoVoluntario!="I"&&this.plazo>60)||(this.clienteserviceParam.datosPrecalificacion.codigoSegmentoRiesgoPagoVoluntario=="I"&&this.plazo>48))){
        if(this.clienteserviceParam.datosCodeudor.cliente!=null){
          this.showPreguntaCodeudor(this.clienteserviceParam.datosCodeudor.cliente.primerNombre,this.clienteserviceParam.datosCodeudor.cliente.primerApellido)
        }else{
          this.clienteserviceParam.datosCliente.needCoDebtor=true
          this.selecttab.emit(12)
        }
      }else{
        this.solicitarOfertas()
      }
    }
  }
  solicitarOfertas(){
    this.ngxUiLoaderService.startLoader("loader-global", "loadingDashboard");
        this.clienteserviceParam
        .solicitarOferta()
        .then((result) => {
          this.ngxUiLoaderService.stopLoader(
            "loader-global",
            "loadingDashboard"
          );
          this.clienteserviceParam.datosPrecalificacion.minimumAmount=this.minimumAmount
          if (result == "R") {
            this.selecttab.emit(11);
          } else if (result == "SD") {
            this.showNotificationsinoferta(
              "No se han obtenido ofertas",
              "Por el momento el cliente no tiene ofertas disponibles."
            );
          } else if (result == "A") {
            if (this.clienteserviceParam.ofertasComerciales.ofertaComercial.length == 2 && this.clienteserviceParam.ofertasComerciales.ofertaComercial[0].bienestarMixAndMatchFlg==1) {
              this.clienteserviceParam.ofertaseleccionada = 0
              this.clienteserviceParam.ofertamym=0
              this.selecttab.emit(13)
            } else {
              this.selecttab.emit(12)
            }
          } else {
            this.showNotificationsinoferta(
              "Ha ocurrido un error",
              "Por el momento el cliente no tiene ofertas disponibles."
            );
          }
        })
        .catch((error) => {
          this.ngxUiLoaderService.stopLoader(
            "loader-global",
            "loadingDashboard"
          );
          if (error.codigoError && error.codigoError == "1003") {
            this.showNotificationsinoferta(
              "Aviso",
              error.mensajeTecnicoAPI
            );
          }
          else if (error.codigoError!="0") {
            this.showNotificationError(
              "Aviso",
              'Ha ocurrido un error, intentelo más tarde. Código de error: '+error.codigoError
            );
          }
          else if (error == "errorguardado") {
            this.showNotificationsinoferta(
              "Ha ocurrido un error",
              "No se ha podido guardar la precalificación."
            );
          } else{
            this.showNotificationError(
              "Alerta",
              "No se ha podido establecer conexión con el servidor, intentelo de nuevo."
            );
          }
        });
  }
  showNotificationsinoferta(title, message) {
    swal
      .fire({
        title: title,
        text: message,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        confirmButtonText: "Continuar",
      })
      .then((result) => {
        this.selecttab.emit(0);
      });
  }
  showNotificationError(title, message) {
    swal
      .fire({
        title: title,
        text: message,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        confirmButtonText: "Continuar",
      })
      .then((result) => {
      });
  }
  showPreguntaCodeudor(nombre, apellido) {
    swal.fire({
      title: 'Alerta',
      text: 'Ya posee el codeudor: '
      +nombre+' '+apellido+'. ¿Desea continuar con este codeudor?',
      confirmButtonColor: '#fff',
      background: '#eeedf2',
      customClass: {
        confirmButton: 'btn button-precas',
        denyButton: 'btn button-precas',
        input: 'inputswt',
        title: 'titleswt'
      },
      showCloseButton: true,
      buttonsStyling: false,
      heightAuto: false,
      showDenyButton: true,
      confirmButtonText: 'Si',
      denyButtonText: 'No',
    }).then(result => {
      if (result.isConfirmed) {
        this.solicitarOfertas()// comparativa mix and match
      } else if (result.isDenied) {
        this.clienteserviceParam.datosCodeudor={}
        this.clienteserviceParam.datosPrecalificacionCodeudor={}
        this.clienteserviceParam.datosCliente.needCoDebtor=true
        this.selecttab.emit(12)
      }
    });
  }
}
